import ApiClient from 'common/ApiClient'

const state = {
  currentDocument: {},
  vacatioLegis: [],
  redactions: [],
  visible: false,
  loadingHistory: false
}

const mutations = {
  setDocument(state, document) {
    state.currentDocument = document
    state.visible = true
  },
  clearDocument(state) {
    state.currentDocument = {}
    state.vacatioLegis = []
    state.redactions = []
    state.visible = false
    state.loadingHistory = false
  },
  setVacatioLegis(state, vacatios) {
    state.vacatioLegis = vacatios
  },
  setRedactions(state, redactions) {
    state.redactions = redactions
  },
  setLoadingHistory(state, loading) {
    state.loadingHistory = loading
  }
}

const actions = {
  async setNavigationDocument({ commit, getters }, document) {
    commit('setDocument', document)
    commit('setVacatioLegis', [])
    commit('setRedactions', [])

    if (getters.hasDocument) {
      commit('setLoadingHistory', true)
      try {
        const api = new ApiClient()
        const response = await api.get(
          `${gon.url_for.document_history.replace(':id', document.id)}`
        )
        if (response.ok) {
            commit('setVacatioLegis', response.data.vacatios || [])
            commit('setRedactions', response.data.redactions || [])
        }
      } catch (e) {
        console.log('** ERROR ON INDEX DOCUMENT LOADING: ', e)
      } finally {
        commit('setLoadingHistory', false)
      }
    }
  },
  clearNavigationDocument({ commit }) {
    commit('clearDocument')
  }
}

const getters = {
  hasDocument: state => Object.keys(state.currentDocument).length > 0,
  hasRedactions: state => state.redactions.length > 0,
  hasVacatios: state => state.vacatioLegis.length > 0,
  hasFutureVacatios: state => state.vacatioLegis.some(v => new Date(v.date) > new Date()),
  isLoading: state => state.loadingHistory
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}